import * as types from "./types";

export const setOperationsTargetUnit = (targetUnit: number) =>
  ({ type: types.SET_TARGET_UNIT, payload: targetUnit } as const);

export type ActionTypes = ReturnType<typeof setOperationsTargetUnit>;
